import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AddressDialogComponent } from '../../../components/dialogs/address/address-dialog.component';
import { BaseController } from '../../../core/abstractions/base.controller';
import { ShareInfoTypeEnum } from '../../../models/enums/share-info-type.enum';
import { ListShareholderModel } from '../../../models/list-shareholder.model';
import { ShareholderSummaryModel } from '../../../models/shareholder-summary.model';
import { ShareholderModel } from '../../../models/shareholder.model';
import { AuthService } from '../../../services/auth.service';
import { ShareholdersResource } from '../../../services/resources/shareholders.resource';

@Component({
    selector: 'sl-shareholders-view',
    templateUrl: './shareholders-view.component.html',
    styleUrls: ['./shareholders-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShareholdersViewComponent
    extends BaseController<ShareholderModel, ShareholderSummaryModel, ListShareholderModel>
    implements OnInit
{
    readonly ShareInfoTypeEnum = ShareInfoTypeEnum;

    readonly canEditAddress = signal(false);

    protected override readonly _entityResource = inject(ShareholdersResource);

    private readonly dialog = inject(MatDialog);
    private readonly authService = inject(AuthService);

    constructor() {
        super();
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.canEditAddress.set(this.authService.hasPermission('UpdateShareholderAddressCommand'));
    }

    openAddressDialog(): void {
        this._entityResource.getAddress(this.recordId()!).subscribe(result => {
            const dialogRef = this.dialog.open(AddressDialogComponent, {
                data: {
                    id: this.recordId(),
                    address: result.value
                },
                minWidth: '650px',
                panelClass: 'sl-address-dialog'
            });
            dialogRef.afterClosed().subscribe(dialogResult => {
                if (!!dialogResult) {
                    this._entityResource
                        .getSummary(this.recordId()!)
                        .subscribe(r => (this.recordSummary()!.formattedAddress = r.value.formattedAddress));
                }
            });
        });
    }
}
